<div class="image-preview-dialog-container">
  <div class="image-preview-header">
    <h2>{{ data.imageName }}</h2>
    <button type="button" (click)="close()" mat-icon-button>
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div class="image-preview-content">
    <img [src]="data.imageUrl" [alt]="data.imageName" />
  </div>
</div>
